import React from 'react';
import { GlassCard } from '../components/GlassCard';
import { MOCK_ASSETS } from '../data/mockData';
import { Badge } from '../components/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiMoreVertical } from 'react-icons/fi';

export const Assets = () => {
  return (
    <div className="space-y-6 max-w-7xl mx-auto h-full flex flex-col">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Asset Mesh</h1>
          <p className="text-slate-400 mt-1">Inventory of currently monitored infrastructure.</p>
        </div>
        <button className="flex items-center gap-2 bg-white/5 hover:bg-white/10 px-4 py-2 rounded-lg text-sm border border-white/10 transition-colors">
          <SafeIcon icon={FiFilter} />
          Filter
        </button>
      </div>

      <GlassCard className="flex-1 overflow-hidden flex flex-col p-0">
        <div className="overflow-x-auto flex-1">
          <table className="w-full text-left text-sm">
            <thead className="text-xs text-slate-400 uppercase bg-black/40 border-b border-white/10">
              <tr>
                <th className="px-6 py-4 font-medium">Asset Name</th>
                <th className="px-6 py-4 font-medium">Type</th>
                <th className="px-6 py-4 font-medium">Status</th>
                <th className="px-6 py-4 font-medium">Risk Score</th>
                <th className="px-6 py-4 font-medium">Last Scanned</th>
                <th className="px-6 py-4 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {MOCK_ASSETS.map((asset) => (
                <tr key={asset.id} className="hover:bg-white/[0.02] transition-colors">
                  <td className="px-6 py-4 font-mono font-medium text-slate-200 whitespace-nowrap">
                    {asset.name}
                  </td>
                  <td className="px-6 py-4 text-slate-400">{asset.type}</td>
                  <td className="px-6 py-4">
                    <Badge type={asset.status} />
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-1.5 bg-slate-800 rounded-full overflow-hidden">
                        <div 
                          className={`h-full ${asset.riskScore > 70 ? 'bg-red-500' : asset.riskScore > 40 ? 'bg-yellow-500' : 'bg-emerald-500'}`}
                          style={{ width: `${asset.riskScore}%` }}
                        />
                      </div>
                      <span className="text-xs font-mono text-slate-400">{asset.riskScore}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-slate-400 text-xs">{asset.lastScanned}</td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-slate-400 hover:text-white p-1">
                      <SafeIcon icon={FiMoreVertical} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </GlassCard>
    </div>
  );
};